import type { OrderRecord } from '@/types/operations.types';

/** Envío más reciente del pedido (order_shipments puede tener varios; el último por fecha). */
export function latestShipment(o: OrderRecord): { carrier: string | null; agency_name: string | null } | null {
  const s = (o.shipments ?? []).filter(Boolean) as NonNullable<OrderRecord['shipments']>;
  if (s.length === 0) return null;
  return [...s].sort((a, b) => String(b.created_at).localeCompare(String(a.created_at)))[0];
}

/**
 * El transportista y la agencia salen del envío que YA VIENE embebido en cada fila: no hay nada
 * que esperar. Se ponen al recibir la lista, antes de pintar.
 *
 * 🪤 ANTES SE PONÍAN EN EL ENRIQUECIMIENTO, que corre después de pintar y espera a la más lenta de
 *    tres consultas (miniaturas, pedidos del cliente, catálogo de couriers). El founder (22-sep-2026):
 *    «al inicio demora en cargar, luego de varios segundos recién aparece el transporte y el
 *    transportista». El NOMBRE nunca dependió de esas consultas; sólo el logo y el tipo (Agencia /
 *    Motorizado), que siguen llegando después. La columna dice «Shalom» desde el primer cuadro y
 *    después le llega el logo.
 */
export function ponerTransportistaDesdeElEnvio(orders: OrderRecord[]): void {
  for (const o of orders) {
    const envio = latestShipment(o);
    o.transport_carrier = envio?.carrier ?? null;
    o.transport_agency = envio?.agency_name ?? null;
  }
}
